(function () {
  var PRODUCT_GROUPS = {
    'original-dashi': ['dashi-original', 'dashi-original-light-sodium'],
    'ultra-premium-dashi': ['dashi-ultra-premium'],
    'vegetable-dashi': ['dashi-vegetable', 'dashi-vegetable-light-sodium'],
    'kelp-dashi': ['dashi-kelp'],
    'mushroom-dashi': ['dashi-mushroom'],
    salt: [
      'kayanoya-basil-garlic-sea-salt-30g',
      'kayanoya-garlic-red-chili-pepper-spinach-sea-salt-40g',
      'kayanoya-dashi-infused-umami-sea-salt-50g',
      'kayanoya-black-pepper-sea-salt-45g'
    ],
    'soy-sauce': [
      'kayanoya-double-aging-soy-sauce-300ml',
      'kayanoya-double-aging-soy-sauce-sweet-300ml',
      'umami-dashi-and-sauce-for-pasta-soy-sauce'
    ],
    vinegar: ['rice-vinegar-for-sushi-300-ml']
  };

  var FACETS = [
    {
      key: 'category',
      title: 'Recipe Category',
      order: ['Soup', 'Main course', 'Salad', 'Appetizer', 'Side dish', 'Snack', 'Bread', 'Dessert', 'Beverage', 'Sauce']
    },
    { key: 'season', title: 'Season', order: ['All season', 'Spring', 'Summer', 'Fall', 'Winter'] },
    {
      key: 'cuisine',
      title: 'Cuisine Type',
      order: ['Japanese', 'American', 'Mexican', 'European', 'Asian']
    },
    { key: 'time', title: 'Cooking Time', order: ['Under 15 minutes', '15–30 minutes', '30–60 minutes', 'Over 1 hour'] },
    { key: 'difficulty', title: 'Difficulty', order: ['Easy', 'Medium', 'Hard'] },
    { key: 'product', title: 'Kayanoya Product', limit: 8, dynamic: true }
  ];

  function slug(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function splitValues(value) {
    return String(value || '')
      .replace(/\s+and\s+/gi, ',')
      .replace(/\//g, ',')
      .split(',')
      .map(function (item) { return item.trim(); })
      .filter(Boolean);
  }

  function uniq(values) {
    var seen = {};
    return values.filter(function (value) {
      var key = slug(value);
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function canonicalCategory(value) {
    var key = slug(value);
    var map = {
      'main-course': 'Main course',
      'main-dish': 'Main course',
      'side-dish': 'Side dish',
      appetizer: 'Appetizer',
      salad: 'Salad',
      soup: 'Soup',
      snack: 'Snack',
      snacks: 'Snack',
      bread: 'Bread',
      dessert: 'Dessert',
      beverage: 'Beverage',
      sauce: 'Sauce'
    };
    return map[key] || null;
  }

  function canonicalSeason(value) {
    var key = slug(value);
    var map = {
      spring: 'Spring',
      summer: 'Summer',
      fall: 'Fall',
      autumn: 'Fall',
      winter: 'Winter',
      'all-seasons': 'All season',
      'all-season': 'All season'
    };
    return map[key] || null;
  }

  function canonicalCuisine(value) {
    var key = slug(value);
    var map = {
      japanes: 'Japanese',
      japanese: 'Japanese',
      'japanese-fusion': 'Japanese',
      american: 'American',
      hawaiian: 'American',
      peruvian: 'American',
      mexican: 'Mexican',
      frech: 'European',
      french: 'European',
      italian: 'European',
      british: 'European',
      european: 'European',
      spanish: 'European',
      german: 'European',
      russian: 'European',
      swedish: 'European',
      swiss: 'European',
      jewish: 'European',
      chinese: 'Asian',
      indian: 'Asian',
      thai: 'Asian',
      korean: 'Asian',
      vietnamese: 'Asian'
    };
    if (map[key]) return map[key];
    if (['main-course', 'side-dish', 'soup'].indexOf(key) !== -1) return null;
    return null;
  }

  function canonicalDifficulty(value) {
    var key = slug(value);
    if (key === 'easy') return 'Easy';
    if (key === 'medium') return 'Medium';
    if (key === 'hard') return 'Hard';
    return null;
  }

  function cookingMinutes(value) {
    var text = String(value || '').toLowerCase();
    if (!text) return null;
    var hourMatch = text.match(/(\d+)\s*hour/);
    var minMatch = text.match(/(\d+)\s*min/);
    var minutes = 0;
    if (hourMatch) minutes += parseInt(hourMatch[1], 10) * 60;
    if (minMatch) minutes += parseInt(minMatch[1], 10);
    if (!minutes) {
      var numMatch = text.match(/\d+/);
      minutes = numMatch ? parseInt(numMatch[0], 10) : 0;
    }
    if (/\+/.test(text) && minutes >= 60) minutes += 1;
    return minutes || null;
  }

  function cookingBucket(value) {
    var minutes = cookingMinutes(value);
    if (minutes === null) return null;
    if (minutes < 15) return 'Under 15 minutes';
    if (minutes <= 30) return '15–30 minutes';
    if (minutes <= 60) return '30–60 minutes';
    return 'Over 1 hour';
  }

  function optionSort(facet, options) {
    var order = facet.order || [];
    return options.sort(function (a, b) {
      var ai = order.indexOf(a.label);
      var bi = order.indexOf(b.label);
      if (ai !== -1 || bi !== -1) return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
      if (b.count !== a.count) return b.count - a.count;
      return a.label.localeCompare(b.label);
    });
  }

  function normalizeArticle(article) {
    var products = (article.used_in_recipe && article.used_in_recipe.length ? article.used_in_recipe : article.products) || [];
    var productValues = products.map(function (product) {
      return { label: product.title, value: product.handle };
    }).filter(function (product) {
      return product.label && product.value;
    });

    var categories = splitValues(article.category).map(canonicalCategory).filter(Boolean);
    var seasons = splitValues(article.season).map(canonicalSeason).filter(Boolean);
    var cuisines = splitValues(article.cuisine).map(canonicalCuisine).filter(Boolean);
    var difficulty = canonicalDifficulty(article.difficulty);
    var time = cookingBucket(article.cooking_time);
    var ingredients = Array.isArray(article.ingredients) ? article.ingredients.join(' ') : '';
    var searchText = [
      article.title,
      article.excerpt,
      article.keywords,
      ingredients,
      productValues.map(function (product) { return product.label; }).join(' '),
      categories.join(' '),
      seasons.join(' '),
      cuisines.join(' ')
    ].join(' ').toLowerCase();

    return {
      raw: article,
      product: productValues,
      category: uniq(categories),
      season: uniq(seasons),
      cuisine: uniq(cuisines),
      time: time ? [time] : [],
      difficulty: difficulty ? [difficulty] : [],
      searchText: searchText
    };
  }

  function readState() {
    var params = new URLSearchParams(window.location.search);
    var state = { q: params.get('q') || '', page: parseInt(params.get('recipe_page') || '1', 10) || 1 };
    FACETS.forEach(function (facet) {
      var values = params.get(facet.key);
      state[facet.key] = values ? values.split(',').map(decodeURIComponent).filter(Boolean) : [];
    });
    applyTaggedPathState(state);
    return state;
  }

  function applyTaggedPathState(state) {
    var match = window.location.pathname.match(/\/tagged\/([^/?#]+)/);
    if (!match) return;
    var tag = slug(decodeURIComponent(match[1]));
    var categoryMap = {
      soup: 'soup',
      'main-course': 'main-course',
      salad: 'salad',
      appetizer: 'appetizer',
      'side-dish': 'side-dish',
      snack: 'snack',
      bread: 'bread',
      dessert: 'dessert',
      beverage: 'beverage',
      sauce: 'sauce'
    };
    var productMap = {
      'original-dashi': PRODUCT_GROUPS['original-dashi'],
      'ultra-premium-dashi': PRODUCT_GROUPS['ultra-premium-dashi'],
      'vegetable-dashi': PRODUCT_GROUPS['vegetable-dashi'],
      'low-sodium-original-dashi': ['dashi-original-light-sodium'],
      'low-sodium-vegetable-dashi': ['dashi-vegetable-light-sodium'],
      'kelp-dashi': PRODUCT_GROUPS['kelp-dashi'],
      'mushroom-dashi': PRODUCT_GROUPS['mushroom-dashi'],
      salt: PRODUCT_GROUPS.salt,
      'soy-sauce': PRODUCT_GROUPS['soy-sauce'],
      'double-aging-soy-sauce': ['kayanoya-double-aging-soy-sauce-300ml'],
      vinegar: PRODUCT_GROUPS.vinegar,
      udon: ['hand-stretched-udon-noodles'],
      'soba-noodles': ['soba-noodles'],
      'dashi-ramen': ['dashi-ramen-sesame-miso']
    };
    if (!state.category.length && categoryMap[tag]) state.category = [categoryMap[tag]];
    if (!state.product.length && productMap[tag]) state.product = productMap[tag];
  }

  function writeState(state) {
    var params = new URLSearchParams(window.location.search);
    params.delete('view');
    if (state.q) params.set('q', state.q); else params.delete('q');
    FACETS.forEach(function (facet) {
      if (state[facet.key] && state[facet.key].length) params.set(facet.key, state[facet.key].join(','));
      else params.delete(facet.key);
    });
    if (state.page > 1) params.set('recipe_page', String(state.page)); else params.delete('recipe_page');
    var query = params.toString();
    var path = window.location.pathname.replace(/\/tagged\/[^/?#]+\/?$/, '/');
    window.history.replaceState({}, '', path + (query ? '?' + query : ''));
  }

  function getArticleFacetValues(article, key) {
    if (key === 'product') return article.product.map(function (product) { return product.value; });
    return article[key].map(slug);
  }

  function matches(article, state, excludedFacet) {
    if (state.q) {
      var terms = state.q.toLowerCase().split(/\s+/).filter(Boolean);
      if (!terms.every(function (term) { return article.searchText.indexOf(term) !== -1; })) return false;
    }

    return FACETS.every(function (facet) {
      if (facet.key === excludedFacet) return true;
      var selected = state[facet.key] || [];
      if (!selected.length) return true;
      var articleValues = getArticleFacetValues(article, facet.key);
      return selected.some(function (value) { return articleValues.indexOf(value) !== -1; });
    });
  }

  function buildOptions(articles, state) {
    var optionsByFacet = {};
    FACETS.forEach(function (facet) {
      var byValue = {};
      var contextualArticles = articles.filter(function (article) {
        return matches(article, state, facet.key);
      });

      contextualArticles.forEach(function (article) {
        var values = facet.key === 'product'
          ? article.product
          : article[facet.key].map(function (label) { return { label: label, value: slug(label) }; });

        values.forEach(function (item) {
          if (!item.value || !item.label) return;
          if (!byValue[item.value]) byValue[item.value] = { label: item.label, value: item.value, count: 0 };
          byValue[item.value].count += 1;
        });
      });
      optionsByFacet[facet.key] = optionSort(facet, Object.keys(byValue).map(function (key) { return byValue[key]; }));
    });
    return optionsByFacet;
  }

  function fetchAll(feedUrl) {
    return fetch(feedUrl)
      .then(function (response) { return response.json(); })
      .then(function (firstPage) {
        var pages = [firstPage];
        var requests = [];
        for (var page = 2; page <= firstPage.total_pages; page += 1) {
          requests.push(fetch(feedUrl + '&page=' + page).then(function (response) { return response.json(); }));
        }
        return Promise.all(requests).then(function (rest) {
          return pages.concat(rest).reduce(function (all, pageData) {
            return all.concat(pageData.articles || []);
          }, []);
        });
      });
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function sortedValues(values) {
    return values.slice().filter(Boolean).sort();
  }

  function hasAnyValue(a, b) {
    var first = sortedValues(a);
    var second = sortedValues(b);
    if (!first.length || !second.length) return false;
    return first.some(function (value) { return second.indexOf(value) !== -1; });
  }

  function paginationRange(current, total) {
    var pages = [];
    var lastAdded = 0;

    for (var page = 1; page <= total; page += 1) {
      var isEdge = page === 1 || page === total;
      var isNearCurrent = Math.abs(page - current) <= 1;
      var isNearStartOrEnd = total <= 7 || page <= 2 || page >= total - 1;

      if (isEdge || isNearCurrent || isNearStartOrEnd) {
        if (lastAdded && page - lastAdded > 1) pages.push('ellipsis-' + page);
        pages.push(page);
        lastAdded = page;
      }
    }

    return pages;
  }

  function init(root) {
    var feedUrl = root.getAttribute('data-feed-url');
    var pageSize = parseInt(root.getAttribute('data-page-size') || '12', 10);
    var state = readState();
    var articles = [];
    var els = {
      toggle: root.querySelector('[data-filter-toggle]'),
      close: root.querySelector('[data-filter-close]'),
      backdrop: root.querySelector('[data-filter-backdrop]'),
      reset: root.querySelector('[data-filter-reset]'),
      search: root.querySelector('[data-filter-search]'),
      groups: root.querySelector('[data-filter-groups]'),
      grid: root.querySelector('[data-filter-grid]'),
      empty: root.querySelector('[data-filter-empty]'),
      loading: root.querySelector('[data-filter-loading]'),
      count: root.querySelector('[data-filter-count]'),
      pagination: root.querySelector('[data-filter-pagination]')
    };

    function updateFilterLinks() {
      document.querySelectorAll('[data-recipe-filter-link]').forEach(function (link) {
        var url = new URL(link.href, window.location.origin);
        var linkPath = url.pathname.replace(/\/$/, '');
        var currentPath = window.location.pathname.replace(/\/$/, '');
        var active = false;

        if (linkPath === currentPath) {
          var linkCategory = url.searchParams.get('category');
          var linkProduct = url.searchParams.get('product');

          if (linkCategory) {
            active = hasAnyValue(state.category || [], linkCategory.split(',').filter(Boolean));
          } else if (linkProduct) {
            active = hasAnyValue(state.product || [], linkProduct.split(',').filter(Boolean));
          }
        }

        link.classList.toggle('active-filter', active);
        if (active) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    function openFilter() {
      root.classList.add('is-filter-open');
      document.body.classList.add('recipe-filter-drawer-open');
      els.toggle.setAttribute('aria-expanded', 'true');
    }

    function closeFilter() {
      root.classList.remove('is-filter-open');
      document.body.classList.remove('recipe-filter-drawer-open');
      els.toggle.setAttribute('aria-expanded', 'false');
    }

    if (root.getAttribute('data-initial-open') === 'true') {
      openFilter();
    }

    function renderGroups() {
      var optionsByFacet = buildOptions(articles, state);
      els.search.value = state.q || '';
      els.groups.innerHTML = FACETS.map(function (facet) {
        var options = optionsByFacet[facet.key] || [];
        var hiddenClass = facet.limit ? ' data-limited="' + facet.limit + '"' : '';
        var hasMoreOptions = facet.limit && options.length > facet.limit;
        var selectedValues = state[facet.key] || [];
        var shouldExpand = hasMoreOptions && options.some(function (option, index) {
          return index >= facet.limit && selectedValues.indexOf(option.value) !== -1;
        });
        return '<div class="recipe-filter__group" data-filter-group="' + facet.key + '"' + hiddenClass + '>' +
          '<button class="recipe-filter__group-toggle" type="button" data-group-toggle aria-expanded="true">' +
            '<span>' + escapeHtml(facet.title) + '</span>' +
            '<span class="recipe-filter__group-caret" aria-hidden="true">v</span>' +
          '</button>' +
          '<div class="recipe-filter__options">' +
          options.map(function (option, index) {
            var hidden = facet.limit && index >= facet.limit
              ? ' class="recipe-filter__option is-extra"' + (shouldExpand ? '' : ' hidden')
              : ' class="recipe-filter__option"';
            var checked = (state[facet.key] || []).indexOf(option.value) !== -1 ? ' checked' : '';
            return '<label' + hidden + '>' +
              '<input type="checkbox" value="' + escapeHtml(option.value) + '" data-facet="' + facet.key + '"' + checked + '>' +
              '<span>' + escapeHtml(option.label) + ' <span class="recipe-filter__option-count">(' + option.count + ')</span></span>' +
            '</label>';
          }).join('') +
          '</div>' +
          (hasMoreOptions ? '<button type="button" class="recipe-filter__view-more" data-view-more>' + (shouldExpand ? 'View less' : 'View more') + '</button>' : '') +
        '</div>';
      }).join('');
    }

    function renderCards(articles) {
      var filtered = articles.filter(function (article) { return matches(article, state); });
      var totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
      if (state.page > totalPages) state.page = totalPages;
      var start = (state.page - 1) * pageSize;
      var pageArticles = filtered.slice(start, start + pageSize);

      els.count.textContent = filtered.length + ' recipes';
      els.empty.hidden = filtered.length > 0;
      els.grid.hidden = filtered.length === 0;
      els.grid.innerHTML = pageArticles.map(function (article) {
        var raw = article.raw;
        return '<article class="recipe-filter__card">' +
          '<a class="recipe-filter__card-image" href="' + escapeHtml(raw.url) + '">' +
            (raw.image ? '<img src="' + escapeHtml(raw.image) + '" alt="' + escapeHtml(raw.image_alt || raw.title) + '" loading="lazy">' : '') +
          '</a>' +
          '<div class="recipe-filter__card-body">' +
            '<h3 class="recipe-filter__card-title"><a href="' + escapeHtml(raw.url) + '">' + escapeHtml(raw.title) + '</a></h3>' +
          '</div>' +
        '</article>';
      }).join('');

      els.pagination.innerHTML = '';
      if (totalPages > 1) {
        var prevButton = document.createElement('button');
        prevButton.type = 'button';
        prevButton.className = 'recipe-filter__page recipe-filter__page--prev';
        prevButton.textContent = 'Prev';
        prevButton.setAttribute('data-page', Math.max(1, state.page - 1));
        if (state.page === 1) prevButton.disabled = true;
        els.pagination.appendChild(prevButton);

        paginationRange(state.page, totalPages).forEach(function (page) {
          if (typeof page === 'string') {
            var ellipsis = document.createElement('span');
            ellipsis.className = 'recipe-filter__page recipe-filter__page--ellipsis';
            ellipsis.textContent = '...';
            els.pagination.appendChild(ellipsis);
            return;
          }

          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'recipe-filter__page' + (page === state.page ? ' is-active' : '');
          button.textContent = page;
          button.setAttribute('data-page', page);
          els.pagination.appendChild(button);
        });

        var nextButton = document.createElement('button');
        nextButton.type = 'button';
        nextButton.className = 'recipe-filter__page recipe-filter__page--next';
        nextButton.textContent = 'Next';
        nextButton.setAttribute('data-page', Math.min(totalPages, state.page + 1));
        if (state.page === totalPages) nextButton.disabled = true;
        els.pagination.appendChild(nextButton);
      }
      writeState(state);
      updateFilterLinks();
    }

    fetchAll(feedUrl).then(function (rawArticles) {
      articles = rawArticles.map(normalizeArticle);
      els.loading.hidden = true;
      renderGroups();
      renderCards(articles);

      els.toggle.addEventListener('click', function () {
        if (root.classList.contains('is-filter-open')) closeFilter();
        else openFilter();
      });

      els.close.addEventListener('click', closeFilter);
      els.backdrop.addEventListener('click', closeFilter);

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && root.classList.contains('is-filter-open')) closeFilter();
      });

      els.reset.addEventListener('click', function () {
        state = readState();
        state.q = '';
        state.page = 1;
        FACETS.forEach(function (facet) { state[facet.key] = []; });
        renderGroups();
        renderCards(articles);
      });

      els.search.addEventListener('input', function () {
        state.q = els.search.value.trim();
        state.page = 1;
        renderGroups();
        renderCards(articles);
      });

      els.groups.addEventListener('change', function (event) {
        if (!event.target.matches('[data-facet]')) return;
        var facet = event.target.getAttribute('data-facet');
        var value = event.target.value;
        state[facet] = state[facet] || [];
        if (event.target.checked && state[facet].indexOf(value) === -1) state[facet].push(value);
        if (!event.target.checked) state[facet] = state[facet].filter(function (item) { return item !== value; });
        state.page = 1;
        renderGroups();
        renderCards(articles);
      });

      els.groups.addEventListener('click', function (event) {
        if (event.target.closest('[data-group-toggle]')) {
          var toggle = event.target.closest('[data-group-toggle]');
          var toggleGroup = toggle.closest('[data-filter-group]');
          var isCollapsed = toggleGroup.classList.toggle('is-collapsed');
          toggle.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
          return;
        }

        var viewMoreButton = event.target.closest('[data-view-more]');
        if (!viewMoreButton) return;
        var group = viewMoreButton.closest('[data-filter-group]');
        var isExpanded = group.classList.toggle('is-expanded');
        group.querySelectorAll('.recipe-filter__option.is-extra').forEach(function (label) {
          label.hidden = !isExpanded;
        });
        viewMoreButton.textContent = isExpanded ? 'View less' : 'View more';
      });

      els.pagination.addEventListener('click', function (event) {
        if (!event.target.matches('[data-page]')) return;
        state.page = parseInt(event.target.getAttribute('data-page'), 10);
        renderCards(articles);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      document.addEventListener('click', function (event) {
        var link = event.target.closest('[data-recipe-filter-link]');
        if (!link) return;
        var url = new URL(link.href);
        var linkPath = url.pathname.replace(/\/$/, '');
        var currentPath = window.location.pathname.replace(/\/$/, '');
        if (linkPath !== currentPath) return;
        event.preventDefault();
        state.q = url.searchParams.get('q') || '';
        state.page = 1;
        FACETS.forEach(function (facet) {
          var value = url.searchParams.get(facet.key);
          state[facet.key] = value ? value.split(',').filter(Boolean) : [];
        });
        renderGroups();
        renderCards(articles);
        closeFilter();
      });
    }).catch(function () {
      els.loading.textContent = 'Recipe data could not be loaded.';
    });
  }

  function boot() {
    document.querySelectorAll('[data-recipe-filter]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.KayanoyaRecipeFilter = window.KayanoyaRecipeFilter || {};
  window.KayanoyaRecipeFilter.productGroups = PRODUCT_GROUPS;
})();
